import { Flex, Link, Text } from "@radix-ui/themes";

interface AuthFooterProps {
    align?: "start" | "center" | "end";
    border?: boolean;
}

const Footer = ({ align = "center", border = true }: AuthFooterProps) => {
    return (
        <Flex
            gap="3"
            justify={align}
            align="center"
            p="4"
            style={{
                paddingTop: "12px",
                borderTop: border ? "1px solid var(--gray-5)" : "none",
            }}
        >
            <Link href="https://legal.desktopcommander.app/#/terms_of_service" target="_blank" rel="noopener noreferrer" size="2" color="gray">
                Terms
            </Link>
            <Text size="2" color="gray">
                |
            </Text>
            <Link href="https://legal.desktopcommander.app/#/remote_privacy_policy" target="_blank" rel="noopener noreferrer" size="2" color="gray">
                Privacy
            </Link>
            <Text size="2" color="gray">
                |
            </Text>
            <Link href="https://status.desktopcommander.app" target="_blank" rel="noopener noreferrer" size="2" color="gray">
                Status
            </Link>
        </Flex>
    );
};

export default Footer;
